import React from 'react';

import DraftPlanIcon from '../../../assets/svg/Plan/DetailHeader/DraftPlanIcon';
import FinishedPlanIcon from '../../../assets/svg/Plan/DetailHeader/FinishedPlanIcon';
import PlanningPlanIcon from '../../../assets/svg/Plan/DetailHeader/PlanningPlanIcon';
import ProgressPlanIcon from '../../../assets/svg/Plan/DetailHeader/ProgressPlanIcon';
import { PlanStatus } from '../../../domain/plan/PlanStatus';

type PlanStatusIconProps = {
  status: PlanStatus;
  color?: string;
  style?: React.CSSProperties;
};

export const PlanStatusIcon = ({ status, style, color }: PlanStatusIconProps) => {
  return status === `draft` ? (
    <DraftPlanIcon style={style} color={color} />
  ) : status === `planning` ? (
    <PlanningPlanIcon style={style} color={color} />
  ) : status === `in_progress` ? (
    <ProgressPlanIcon style={style} color={color} />
  ) : (
    <FinishedPlanIcon style={style} color={color} />
  );
};
